// @ts-nocheck
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'

import { accountActionForGuestCheckout } from '../../../actions/auth.action'
import { fetchPublicTemplatesCall } from '../../../actions/enrollment.action'
import localStorageService from '../../../api/localStorageService'
import PaymentSuccessGuestCheckout from '../../../components/sis/student/paymentsuccessguestcheckout/PaymentSuccessGuestCheckout'
import { selectSchool } from '../../../helpers/selectors'
import { isEmpty, noop } from '../../../helpers/utils'

function PaymentSuccessGuestCheckoutContainer({
  school,
  accountActionForGuestCheckout,
  fetchPublicTemplatesCall,
}) {
  const params = useParams()
  const [thankYouMessage, setThankYouMessage] = useState('')

  const getTemplateCall = () => {
    fetchPublicTemplatesCall(school.sch_id, 'store_checkout_thankyou_message.html', (data) => {
      setThankYouMessage(data)
    })
  }

  React.useEffect(() => {
    const updatedParams = { ...params, guest_customer: true }
    accountActionForGuestCheckout(
      updatedParams,
      () => {
        localStorageService.setDistrictSchool(params)
      },
      () => {
        localStorageService.clearDistrictSchool()
      }
    )
  }, [])

  React.useEffect(() => {
    if (!isEmpty(school)) {
      getTemplateCall()
    }
  }, [school])
  return <PaymentSuccessGuestCheckout school={school} thankYouMessage={thankYouMessage} />
}

PaymentSuccessGuestCheckoutContainer.propTypes = {
  school: PropTypes.object,
  accountActionForGuestCheckout: PropTypes.func,
  fetchPublicTemplatesCall: PropTypes.func,
}

PaymentSuccessGuestCheckoutContainer.defaultProps = {
  school: {},
  accountActionForGuestCheckout: noop,
  fetchPublicTemplatesCall: noop,
}

const mapStateToProps = (state) => ({
  school: selectSchool(state),
})

export default connect(mapStateToProps, {
  accountActionForGuestCheckout,
  fetchPublicTemplatesCall,
})(PaymentSuccessGuestCheckoutContainer)
